<template>
  <div class="submain__terrenos-custom">
    <div class="line__vertical-mains "></div>
    <button-back/>
    <div v-if="locations.length > 0" class="map_filter">
      <div class="select__box box-terrenos">
        <Range class="ranges-mobile" v-if="locations.length > 0 && filtersCalculated" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
        <Availables
            class="availables-mobile"
            :type="type"
            :amountAvailables="amountAvailables"
        />
        <!-- <Promotion class="promotion_mobile">36</Promotion> -->
      </div>
      <div class="maphighlight__box">
          <h1 class="caption__select">
                  <span>Seleccione un terreno, clic para ver detalles</span>
                </h1>
        <map-highlight v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img"  :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel"/>
        <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img"/>
        <div class="line_horizontal ranges-desk"></div>
        
      </div>
      <div class="select__box">
        <!-- <Select
            v-if="locations.length > 0 && rangeFilter.length > 0"
            :locations="locations"
            @change="changeRange"
            :rangeFilter="rangeFilter"
        /> -->
        <Availables
            class="availables-desk"
            :type="type"
            :amountAvailables="amountAvailables"
        />
        <Range class="ranges-desk" v-if="locations.length > 0 && filtersCalculated" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
        <!-- <Promotion class="promotion_web">36</Promotion> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlight from "../../core/MapHighlight";
/* import Select from "../../core/Select.vue"; */
import Availables from "../../core/Availables.vue";
import Button from "../../core/Button.vue";
import ButtonBack from "../../core/ButtonBack";
import Range from "../../core/Range.vue";
/* import Promotion from "../../core/Promotion.vue ;"*/
export default {
  name: "Etapa",
  components: {
    MapHighlight,
    /* Select, */
    Availables,
    Button,
    ButtonBack,
    Range,
   /*  Promotion */
  },
  data() {
    return {
      id: 33,
      levelId: this.$route.params.idPiso,
      type: "terreno",
      desarrollo: "paseodelparque",
      arrFilteredLocations: [],
      nivel: "availability",
      url: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
      imgSet: [
        {
          name: 'paseodelparque',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/paseodelparque/etapas/pdp-etapa5xActualizado.webp',
          width: '3997',
          height: '3264',
          id: 55,
          route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
          nivel: 'availability',
          levelId: this.$route.params.idPiso,
          transform: '',
          viewBox: '0 0 3997 3264'
        }
      ],
      // si no hay filtro volver rangeFilter a false
      rangeSliderFilter:[null,null],
            rangeFilterPrice:[null,null],
            rangeFilter: [
              { min: 0, max: 0 }
      ],
            filtersCalculated: false
    };
  },

  computed: {
    ...mapGetters({
      locations: "getLocations",
    }),
    development() {
      return { id: this.id, level: this.levelId };
    },
    amountAvailables() {
      const filteredAvailables = this.existFilter;
      const newArrfiltered = filteredAvailables.filter(
          (item) => item.status == 2
      );
      return newArrfiltered;
    },
    existFilter() {
      let arrExistFilter;
      if (this.rangeFilter) {
        arrExistFilter = this.arrFilteredLocations;
      } else if (this.rangeFilter === false) {
        arrExistFilter = this.locations;
      }
      return arrExistFilter;
    },
  },
  methods: {
    ...mapActions(["getAvailableLocations", "clearCoords"]),
    changeRange(arrFilter) {
      this.arrFilteredLocations = arrFilter;
    },
  },
  async created() {
    await this.getAvailableLocations(this.development);
  },
  async beforeDestroy(){
    await this.clearCoords()
  },
  watch: {
    locations(newVal) {
      if (newVal.length > 0) {
        const m2tValues = newVal
          .filter(item => item.m2t != null)
          .map(item => Number(item.m2t));

        if (m2tValues.length > 0) {
          const min = Math.floor(Math.min(...m2tValues));
          const max = Math.ceil(Math.max(...m2tValues)); 

          this.rangeSliderFilter = [min, max];
        } else {
          this.rangeSliderFilter = [0, 0];
        }

        const prices = newVal.map(item => item.value);
        if (prices.length > 0) {
          const minPrice = Math.floor(Math.min(...prices));
          const maxPrice = Math.ceil(Math.max(...prices)); 

          this.rangeFilterPrice = [minPrice, maxPrice];
          const step = Math.ceil((maxPrice - minPrice + 1) / 3);

          this.rangeFilter = [
            { min: minPrice, max: minPrice + step - 1 },
            { min: minPrice + step, max: minPrice + step * 2 - 1 },
            { min: minPrice + step * 2, max: maxPrice },
          ];
          this.filtersCalculated=true
        } else {
          this.rangeFilterPrice = [null, null];
          this.rangeFilter = [];
        }

        this.arrFilteredLocations = newVal;
      }
    }
  }
};
</script>
